import { useMemo } from 'react';
import { LINE_HEIGHT } from '../../../constants';

/**
 * Calculates how many rows are available and what to display
 * Returns: { titleRows, shouldShowSubtitle, shouldShowTime }
 */
export const useCalculateDisplayRows = ({ hasSubtitle, height }: { hasSubtitle: boolean; height: number }) =>
  useMemo(() => {
    const availableRows = Math.floor(height / LINE_HEIGHT);

    if (availableRows <= 0) {
      return { shouldShowSubtitle: false, shouldShowTime: false, titleRows: 0 };
    }

    if (availableRows === 1) {
      // 1 row: show 1 row of title only
      return { shouldShowSubtitle: false, shouldShowTime: false, titleRows: 1 };
    }

    if (availableRows === 2) {
      // 2 rows: show 1 row of title + (subtitle if available, otherwise time)
      if (hasSubtitle) {
        return { shouldShowSubtitle: true, shouldShowTime: false, titleRows: 1 };
      }
      return { shouldShowSubtitle: false, shouldShowTime: true, titleRows: 1 };
    }

    // 3+ rows: show title (remaining rows - 2 for subtitle and time) + subtitle + time
    // If no subtitle, use that row for title instead
    const rowsForSubtitleAndTime = hasSubtitle ? 2 : 1;
    const titleRows = Math.max(1, availableRows - rowsForSubtitleAndTime);
    return { shouldShowSubtitle: hasSubtitle, shouldShowTime: true, titleRows };
  }, [height, hasSubtitle]);
